import React from 'react';

import { ListProps } from 'react-admin';

export const UsersList: React.FC<ListProps> = () => {
  return <></>;
};
